import React from 'react';
import Bar from './Bar';
import BarBoxItem from './BarBoxItem';
import PropTypes from 'prop-types';
import CalciteChip from '../../shared/CalciteChip';

const SalesRepIcon = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
		<path d="M20 15.9A6.9 6.9 0 1 0 13.1 9a6.908 6.908 0 0 0 6.9 6.9zm0-13A6.1 6.1 0 1 1 13.9 9 6.107 6.107 0 0 1 20 2.9zm-6.314 41.2H20v.8h-6.314a2.589 2.589 0 0 1-2.586-2.586v-1.867a2.585 2.585 0 0 1-2.18-2.742l.956-12.593a6.47 6.47 0 0 1 6.438-6.012h7.057a6.472 6.472 0 0 1 6.439 6.015l.065.874c-.05-.002-.102-.013-.153-.013h-.65l-.06-.803a5.67 5.67 0 0 0-5.64-5.273h-7.059a5.668 5.668 0 0 0-5.64 5.27L9.72 37.765a1.786 1.786 0 0 0 1.781 1.914h.4v2.635a1.787 1.787 0 0 0 1.786 1.786zm21.591-16.025A6.065 6.065 0 0 0 32.5 29.16a6.176 6.176 0 0 0-2.776-1.084H22.1v14.793h7.623a5.92 5.92 0 0 1 2.377.982v.003h.003c.064.04.126.08.172.112l.225.152.225-.152c.046-.032.108-.072.172-.112h.003v-.003a5.92 5.92 0 0 1 2.377-.982H42.9V28.075zm-5.554 13.992H22.9V28.876h6.823a5.566 5.566 0 0 1 2.377.978v13.062a5.55 5.55 0 0 0-2.377-.849zm12.377 0h-6.823a5.549 5.549 0 0 0-2.377.85V29.851a5.445 5.445 0 0 1 2.377-.976H42.1zM37.9 35h-.8v-6h.8zM31 32.1v.8h-7v-.8zm-7 2.971h7v.801h-7zm0 3.029h7v.8h-7z" />
	</svg>
);

function CartMessageBar(props) {
	return (
		<Bar className="cart-message-bar">
			{props.token && props.cart?.metadata?.customer?.customerNumber && (
				<BarBoxItem className="customer-number-box-item" title={props.localizedKeys.shoppingForLabel}>
					<p className="customer-number-box-item__subtitle avenir-regular margin-bottom--1">
						{props.cart.metadata.customer.customerName}
						{isNaN(props.cart.metadata.customer.customerNumber) && props.localizedKeys.newLabel && (
							<CalciteChip scale="s" appearance="outline-fill" kind="inverse">
								{props.localizedKeys.newLabel}
							</CalciteChip>
						)}
					</p>
					{!isNaN(props.cart.metadata.customer.customerNumber) && (
						<p className="customer-number-box-item__body trailer-0">
							{props.localizedKeys.customerNumberLabel}
							{props.cart.metadata.customer.customerNumber}
						</p>
					)}
					<div className="customer-number-box-item__link">
						<calcite-link scale="s" icon-start="edit-attributes" onClick={props.onCustomerNumberClick} class="esri-font-medium">
							{props.localizedKeys.changeLabel}
						</calcite-link>
					</div>
				</BarBoxItem>
			)}
			{props.cart?.metadata?.salesNotes && (
				<BarBoxItem className="sales-rep-box-item" title={props.localizedKeys.fromSalesRepLabel} icon={SalesRepIcon}>
					{props.cart.metadata.salesNotes}
				</BarBoxItem>
			)}
		</Bar>
	);
}

CartMessageBar.propTypes = {
	token: PropTypes.string,
	cart: PropTypes.object,
	localizedKeys: PropTypes.object,
	onCustomerNumberClick: PropTypes.func,
};

export default CartMessageBar;
